export const VisitStatusEnum = {
  NONE: 'none',
  TO_VISIT: 'tovisit',
  VISITED: 'visited',
};

export const PageTabs = {
  EXHIBITORS: 'list',
  MANAGE: 'manage',
};

export const folderActionsEnum = {
  DELETE: 'delete',
  EDIT: 'edit',
};
